var map = {
	"./cross-permission-messages.en.json": "./src/app/shared/service/message-manager/messages/cross-permission/cross-permission-messages.en.json",
	"./cross-permission-messages.it.json": "./src/app/shared/service/message-manager/messages/cross-permission/cross-permission-messages.it.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/shared/service/message-manager/messages/cross-permission sync recursive ^\\.\\/cross\\-permission\\-messages\\..*\\.json$";